import { render } from "./UserManagementTable.vue?vue&type=template&id=1ec58b50&scoped=true"
import script from "./UserManagementTable.vue?vue&type=script&lang=js"
export * from "./UserManagementTable.vue?vue&type=script&lang=js"

import "./UserManagementTable.vue?vue&type=style&index=0&id=1ec58b50&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec58b50"]])

export default __exports__